//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';
import FiltersActions from './filters';
import FreeGiftActions from './freeGift';
import PromotionsActions from './promotions';
import TrackJs from '../Utils/trackjs-interface';
import HelloBarActions from './hellobar';
import MembershipActions from './membership';
import QuoteActions from './quote';

const exposedActions = {
  free_gift_update_ux: FreeGiftActions.updateUXData,
  set_active_promotion: PromotionsActions.setActivePromotion,
  set_hellobar_text: HelloBarActions.setHelloBarText,
  set_additional_hellobar_text: HelloBarActions.setAdditionalHelloBarText,
  set_hellobar_data: HelloBarActions.setData,
  reset_hellobar: HelloBarActions.resetHelloBarText,
  add_or_update_promotion: PromotionsActions.addOrUpdatePromotion,
  set_new_member_plan: MembershipActions.setNewMemberPlan,
  activate_promotion: PromotionsActions.activatePromotion,
  activate_promotions: PromotionsActions.activatePromotions,
  add_filter: FiltersActions.addFilter,
};

export default {
  /**
   * @param experiments: string, object, or array of strings and/or objects
   */
  enableExperiment(experiments:string|string[]|Object[]|Object, version?:string|boolean = true) {
    Dispatcher.dispatchAction(Constants.ENABLE_EXPERIMENT, { experiments, version });
  },

  enableExperiments(...experiments:string[]) {
    Dispatcher.dispatchAction(Constants.ENABLE_EXPERIMENT, { experiments, value: true } );
  },

  disableAllExperiments() {
    Dispatcher.dispatchAction(Constants.DISABLE_ALL_EXPERIMENTS);
  },

  setPromoCode(code:string) {
    QuoteActions.setUrlPromoCode(code);
  },

  performAction(action:string, data:Object) {
    TrackJs.console.debug(`Optimizely runs action ${action}`);
    if (!exposedActions.hasOwnProperty(action)) {
      TrackJs.track('Optimizely tried to use a non exposed action');
    }

    try {
      exposedActions[action](data);
      return true;
    } catch(e) {
      TrackJs.console.debug(`error: ${e}`);
      TrackJs.console.debug('Optimizely error running action');
    }
  },
};
